import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UpdateQaEmailConfigurations as UpdateQaEmailConfigurationsGenerated,
  UpdateQaEmailConfigurationsVariables as UpdateQaEmailConfigurationsVariablesGenerated,
} from "core/queries/__generated__/UpdateQaEmailConfigurations";

export interface UpdateQaEmailConfigurationsResponse
  extends UpdateQaEmailConfigurationsGenerated {}
export interface UpdateQaEmailConfigurationsVariables
  extends UpdateQaEmailConfigurationsVariablesGenerated {}

export const updateQaEmailConfigurations = gql`
  mutation UpdateQaEmailConfigurations(
    $userId: ID!
    $addedCompanyIds: [ID!]
    $removedCompanyIds: [ID!]
  ) {
    updateQaEmailConfiguration(
      userId: $userId
      addedCompanyIds: $addedCompanyIds
      removedCompanyIds: $removedCompanyIds
    ) {
      qaEmailConfigurations {
        id
        user {
          id
          email
        }
        company {
          id
          name
        }
      }
    }
  }
`;

interface UseUpdateQAEmailConfigurationsOptions {
  awaitRefetchQueries?: boolean;
  refetchQueries?: string[];
  variables: UpdateQaEmailConfigurationsVariables;
}

export const useUpdateQaEmailConfigurations = ({
  awaitRefetchQueries = false,
  refetchQueries = [],
  variables,
}: UseUpdateQAEmailConfigurationsOptions) =>
  useMutation<
    UpdateQaEmailConfigurationsResponse,
    UpdateQaEmailConfigurationsVariables
  >(updateQaEmailConfigurations, {
    awaitRefetchQueries,
    refetchQueries,
    variables,
  });
